module.exports = function(value) {
	this.value = value;
}


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/extract-require/constructor.js
 ** module id = 1
 ** module chunks = 0
 **/